import { api } from "..";

 
export interface SyncSelectionProps {
  key: string;
  odds: number;
}

interface Payload {
  lang: string;
  selections: SyncSelectionProps[];
}

export const syncSelections = async (payload: Payload) => {
  const res = await api.client.post("/selections-new/sync", payload);
  return res.data;
};
